import React, { useContext, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Button,
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
// import Datepicker from 'react-datepicker';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Get, JENIS_DUSUN, Post } from '../../function/Koneksi';
import { generateAlamat, Tanggal } from '../../function/Format';

const ModalSuratPernahNikah = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmDex = {
		uuid: "",
		id_jenis: "",
		kk: "",
		agama: "",
		alamat: "",
		jenis_kelamin: "",
		kewarganegaraan: "Indonesia",
		nama_pemohon: "",
		nik: "",
		pekerjaan: "",
		pendidikan_terakhir: "",
		status_perkawinan: "",
		tanggal_lahir: new Date(),
		tempat_lahir: "",

		// pasangan
		agama_pasangan: null,
		alamat_pasangan: "",
		jenis_kelamin_pasangan: "",
		nama_pasangan: "",
		nik_pasangan: "",
		pekerjaan_pasangan: null,
		pendidikan_terakhir_pasangan: "",
		status_perkawinan_pasangan: null,
		tanggal_lahir_pasangan: new Date(),
		tempat_lahir_pasangan: "",

		tanggal_menikah: new Date(),
		tempat_menikah: '',
		petugas_nikah: '',
		wali_nikah: '',
		mas_kawin: '',
		saksi_nikah: '',

		// pasangan
		agama_pelapor: "",
		alamat_pelapor: "",
		jenis_kelamin_pelapor: "",
		nama_pelapor: "",
		nik_pelapor: "",
		pekerjaan_pelapor: "",
		pendidikan_terakhir_pelapor: "",
		status_perkawinan_pelapor: "",
		tanggal_lahir_pelapor: new Date(),
		tempat_lahir_pelapor: "",

		status_ttd: ''
	};

	const initFormData = {
		frmNik: optionData.frmNik,
		frmNik2: optionData.frmNik2,
		frmNik3: optionData.frmNik3,
		frmShdk: optionData.frmShdk,
		frmPkr: optionData.frmPkr,
		frmAgm: optionData.frmAgm,
		frmStatusPerkawinan: optionData.frmStatusPerkawinan,
		tmplistPenduduk: optionData.tmplistPenduduk,
		tmplistPenduduk2: optionData.tmplistPenduduk2,
		tmplistPenduduk3: optionData.tmplistPenduduk3,
		// frmShdk: optionData.frmShdk,
		nikStat: null,
		nik2Stat: null,
		nik3Stat: null,
		// detail: [],
		status: {
			form: false,
			btnForm: false,
			dataPenduduk: optionData.status.dataPenduduk,
			dataPenduduk2: optionData.status.dataPenduduk2,
			dataPenduduk3: optionData.status.dataPenduduk3,
			btnAksi: [],
		},
		formPasangan: 'none',
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			frmNik: optionData.frmNik,
			frmNik2: optionData.frmNik2,
			frmNik3: optionData.frmNik3,
			frmShdk: optionData.frmShdk,
			frmPkr: optionData.frmPkr,
			frmAgm: optionData.frmAgm,
			frmStatusPerkawinan: optionData.frmStatusPerkawinan,
			nikStat: optionData.nikStat,
			nik2Stat: optionData.nik2Stat,
			nik3Stat: optionData.nik3Stat,
			status: optionData.status,
			formPasangan: optionData.formPasangan,
		} : initFormData)
	}, [isOpen])

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false || e && fld == "nik2" || e && fld == "nik3") {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;
					case "nik2":
						setFormData({
							...formData,
							frmNik2: frmNik,
							tmplistPenduduk2: tmplistPenduduk,
							nik2Stat: nikStat
						})
						break;
					case "nik3":
						setFormData({
							...formData,
							frmNik3: frmNik,
							tmplistPenduduk3: tmplistPenduduk,
							nik3Stat: nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeSelectValue = (e, sel) => {
		setDt({
			...dt,
			[sel]: e,
		})
	}

	const dataPasangan = () => {
		let dataPenduduk2 = "block"

		let formPasangan = formData.formPasangan === "" ? "none" : "";

		if (formPasangan !== "") {
			dataPenduduk2 = "none"
		}

		setDt({
			...dt,
			agama_pasangan: null,
			alamat_pasangan: "",
			alamat_kk_pasangan: "",
			jenis_kelamin_pasangan: "",
			nama_pasangan: "",
			nik_pasangan: "",
			pekerjaan_pasangan: null,
			pendidikan_terakhir_pasangan: "",
			status_perkawinan_pasangan: null,
			tanggal_lahir_pasangan: new Date(),
			tempat_lahir_pasangan: "",
		})
		setFormData({
			...formData,
			status: {
				...formData.status,
				dataPenduduk2
			},
			formPasangan,
			nik2Stat: null
		})
	}

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const gantiTgl = (date, fld) => {
		if (typeof date._isValid !== 'undefined') {
			let newVal = ''
			if (fld == "tanggal_lahir_anak") {
				newVal = new Date(date.format('YYYY-MM-DD HH:mm:ss'))
			} else {
				newVal = new Date(date.format('YYYY-MM-DD'))
			}
			setDt({
				...dt,
				[fld]: newVal
			})
		}
	}

	const getPenduduk = (e, jns) => {
		if (e) {
			
            if (kioskMode) {
                props.setLoadingPreview(true)
            }
            else{
                setAlert({
                    loadingPreview: true
                })
            }


			Get("penduduk/find", e.value, data => {
                if(data.results){
                    const alamat = generateAlamat(data.results);
                    let alamat_kk = "";
                
                    if(data.results.data_kk){
                        alamat_kk = data.results.data_kk.alamat
                    }

                    if (jns === "nik") {
                        setDt({
                            ...dt,
                            agama: data.results.data_agama.nama,
                            alamat: alamat,
                            alamat_kk: alamat_kk,
                            jenis_kelamin: {
                                value: data.results.jk,
                                label: data.results.jk,
                            },
                            kk: data.results.id_kk,
                            nama_pemohon: data.results.nama,
                            nama: data.results.nama,
                            nik: data.results.id,
                            pekerjaan: data.results.data_pekerjaan.nama,
                            pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
                            status_perkawinan: data.results.status_perkawinan,
                            tanggal_lahir: data.results.tanggal_lahir,
                            tempat_lahir: data.results.tempat_lahir,
                        })
                        setFormData({
                            ...formData,
                            nikStat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk: "block"
                            },
                        })
                    } else if (jns === "nik2") {
                        setDt({
                            ...dt,
                            agama_pasangan: {
                                value: data.results.data_agama.nama,
                                label: data.results.data_agama.nama,
                            },
                            alamat_pasangan: alamat,
                            alamat_kk_pasangan: alamat_kk,
                            jenis_kelamin_pasangan: {
                                value: data.results.jk,
                                label: data.results.jk,
                            },
                            nama_pasangan: data.results.nama,
                            nik_pasangan: data.results.id,
                            pekerjaan_pasangan: {
                                value: data.results.data_pekerjaan.nama,
                                label: data.results.data_pekerjaan.nama,
                            },
                            pendidikan_terakhir_pasangan: data.results.data_pendidikan_terakhir.nama,
                            status_perkawinan_pasangan: {
                                value: data.results.status_perkawinan,
                                label: data.results.status_perkawinan,
                            },
                            tanggal_lahir_pasangan: data.results.tanggal_lahir,
                            tempat_lahir_pasangan: data.results.tempat_lahir,
                        })
                        setFormData({
                            ...formData,
                            nik2Stat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk2: "block",
                            },
                        })
                    } else if (jns === "nik3") {
                        setFormData({
                            ...formData,
                            nik3Stat: e,
                            status: {
                                ...formData.status,
                                dataPenduduk3: "block",
                            },
                        })
                        setDt({
                            ...dt,
                            agama_pelapor: data.results.data_agama.nama,
                            alamat_pelapor: alamat,
                            alamat_kk_pelapor: alamat_kk,
							jenis_kelamin_pelapor: {
                                value: data.results.jk,
                                label: data.results.jk,
                            },
                            nama_pelapor: data.results.nama,
                            nik_pelapor: data.results.id,
                            pekerjaan_pelapor: data.results.data_pekerjaan.nama,
                            pendidikan_terakhir_pelapor: data.results.data_pendidikan_terakhir.nama,
                            status_perkawinan_pelapor: data.results.status_perkawinan,
                            tanggal_lahir_pelapor: data.results.tanggal_lahir,
                            tempat_lahir_pelapor: data.results.tempat_lahir,
                        })
                    }

                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
                else{
                    if (kioskMode) {
                        props.setLoadingPreview(false)
                    }
                    else{
                        setAlert({
                            loadingPreview: false
                        })
                    }
                }
            })
		} else {
			switch (jns) {
				case "nik":
					// setDt(frmDex)
					setDt({
						...dt,
						nik: '',
						kk: '',
						nama: '',
						nama_pemohon: '',
						tempat_lahir: '',
						tanggal_lahir: null,
						pekerjaan: '',
						jenis_kelamin: '',
						pendidikan_terakhir: '',
						agama: '',
						status_perkawinan: '',
						alamat: '',
						alamat_kk: '',
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk: "none"
						},
						nikStat: null,
					})
					break;
				case "nik2":
					setDt({
						...dt,
						agama_pasangan: null,
						alamat_pasangan: "",
						alamat_kk_pasangan: "",
						jenis_kelamin_pasangan: "",
						nama_pasangan: "",
						nik_pasangan: "",
						pekerjaan_pasangan: null,
						pendidikan_terakhir_pasangan: "",
						status_perkawinan_pasangan: null,
						tanggal_lahir_pasangan: new Date(),
						tempat_lahir_pasangan: "",
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk2: "none"
						},
						nik2Stat: null
					})
					break;
				case "nik3":
					setDt({
						...dt,
						nik_pelapor: '',
						nama_pelapor: '',
						agama_pelapor: '',
						tempat_lahir_pelapor: '',
						tanggal_lahir_pelapor: new Date(),
						jenis_kelamin_pelapor: '',
						pendidikan_terakhir_pelapor: '',
						status_perkawinan_pelapor: '',
						pekerjaan_pelapor: null,
						alamat_pelapor: '',
						alamat_kk_pelapor: '',
					})
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk3: "none"
						},
						nik3Stat: null
					})
					break;
				default:
					break;
			}
		}
	};

	const simpan = (e) => {
		e.preventDefault();

        if (kioskMode){
                props.setLoadingPreview(true)
        }
        else{
            setAlert({
                loadingPreview: true
            })
        
        }
		let validasiPenduduk = false;
		let validasiPasangan = false;
		let validasiPelapor = false;

		// validasi pemohon
		if (formData.nikStat != null) {
			validasiPenduduk = true;
		}

		// validasi pasangan
		// Input manual data pasangan
		if (formData.formPasangan !== "none") {
			if (dt.nik_pasangan !== '' && dt.agama_pasangan && dt.pekerjaan_pasangan && dt.status_perkawinan_pasangan) {
				validasiPasangan = true;
			}
		} else { // data pasangan otomatis
			if (formData.nik2Stat) {
				validasiPasangan = true;
			}
		}

		// validasi pelapor
		if (formData.nik3Stat != null) {
			validasiPelapor = true;
		}

		if (validasiPenduduk && validasiPasangan && validasiPelapor) {
			let tanggal_lahir = new Date(dt.tanggal_lahir);
			let tanggal_lahir_pasangan = new Date(dt.tanggal_lahir_pasangan);
			let tanggal_lahir_pelapor = new Date(dt.tanggal_lahir_pelapor);

			let tanggal_menikah = new Date(dt.tanggal_menikah);

			let bodyRaw = {
				...dt,
				tanggal_lahir: dateFormat(tanggal_lahir, 'yyyy-mm-dd'),
				tanggal_lahir_pasangan: dateFormat(tanggal_lahir_pasangan, 'yyyy-mm-dd'),
				tanggal_lahir_pelapor: dateFormat(tanggal_lahir_pelapor, 'yyyy-mm-dd'),

				tanggal_menikah: dateFormat(tanggal_menikah, 'yyyy-mm-dd'),

				agama_pasangan: dt.agama_pasangan.label,
				jenis_kelamin: dt.jenis_kelamin.label,
				jenis_kelamin_pasangan: dt.jenis_kelamin_pasangan.label,
				jenis_kelamin_pelapor: dt.jenis_kelamin_pelapor.label,
				pekerjaan_pasangan: dt.pekerjaan_pasangan.label,
				status_perkawinan_pasangan: dt.status_perkawinan_pasangan.label,

			};

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			Post(
				"surat-keterangan/pernah-menikah/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					// Kalau mode kiosk
					if (kioskMode) {
						if (res.status === resstat) {
                            let dataAntrian = {
                                nama: props.data.results.nama,
                                nik: props.data.results.id,
                                keterangan: '',
                                uuid_surat:res.data.results.uuid_surat,
                                kode_surat:res.data.results.kode_surat,
                            };
                    
                            // Set Data Surat
                            props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null, (res2) => {
									
									props.setLoadingPreview(false)

									if (res2.code === 201) {
										props.getAntrian('Surat Keterangan Pernah Menikah', 'berhasil', false, dataAntrian);
									}
									else {
										props.getAntrian('Surat Keterangan Pernah Menikah', 'gagal');
									}
								});
							}.bind(this),1000)
                        }
                        else{
							props.setLoadingPreview(false)
                            props.getAntrian('Surat Keterangan Pernah Menikah', 'gagal');
                        }
					} else { // Kalau bukan kiosk
						if (res.status === resstat) {
                            const alertData = {
                                get_data_surat:{
                                    uuid_surat:res.data.results.uuid_surat,
                                    kode_surat:res.data.results.kode_surat,
                                },
                                status:{
                                    frmPreviewDraft: true,
                                    jenis_form: psn,
                                }
                                // show: true,
                                // basicType: "success",
                                // basicTitle: "Data Surat Keterangan Kematian V2",
                                // pesanAlert: "Berhasil " + psn + " Data",
                                // successAlert: true
                            };
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData)
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Surat Keterangan Pernah Menikah",
								pesanAlert: "Gagal " + psn + " Data"
							}
							setAlert({
							  	loadingPreview: false
							})
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}
				}
			);

		} else {
			if (kioskMode){
				props.getAntrian('Surat Keterangan Kematian V2', 'gagal', true);
				props.setLoadingPreview(false)
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				setAlert({
					loadingPreview: false
				})
				setAlert(alertData)
			}
		}

	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: "60%", maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				style={{
					// maxHeight: "550px", overflowY: "scroll"
				}}
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
					<div className="modal-header">
						<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Surat Keterangan Pernah Menikah</h5>
					</div>
					<div className="modal-body">
						<input
							className="form-control"
							id="uuid"
							type="hidden"
							placeholder=""
							defaultValue={dt.uuid}
						/>

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik");
										}}
										defaultValue={formData.nikStat}
										value={formData.nikStat}
										name="nik"
										options={formData.frmNik}
										placeholder="Pilih NIK Penduduk"
										onInputChange={e => handleInputChangeNIK(e, 'nik')}
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>
						<div style={{ display: formData.status.dataPenduduk }}>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pemohon
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pemohon"
										type="text"
										placeholder="Nama Pemohon"
										value={dt.nama_pemohon}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tempat_lahir"
										type="text"
										placeholder="Tempat Lahir"
										value={dt.tempat_lahir}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir"
										type="text"
										placeholder="Tanggal Lahir"
										value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
										readOnly
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat_kk"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_kk}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                    <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                </Col>
                            </FormGroup>
						</div>

						<hr />
						<FormGroup className="row mb-1">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik2"
							>
								NIK Pasangan
							</Label>
							<Col sm="9">
								{formData.formPasangan === "none" ? (
									<div data-testid="selectNIK2">
										<Select
											inputId="nik2"
											isDisabled={formData.status.select}
											classNamePrefix="select"
											onChange={e => {
												getPenduduk(e, "nik2");
											}}
											defaultValue={formData.nik2Stat}
											value={formData.nik2Stat}
											name="penduduk"
											onInputChange={e => handleInputChangeNIK(e, "nik2")}
											options={formData.frmNik2}
											placeholder="Pilih NIK Pasangan"
											isClearable
										/>
									</div>
								) : (
									<></>
								)}
								<input
									data-testid="nik_pasangan"
									name="nik_pasangan"
									className="form-control"
									id="nik_pasangan"
									type={formData.formPasangan === "none" ? "hidden" : "text"}
									pattern="\d{1,16}"
									maxLength={16}
									minLength={16}
									required
									placeholder="Masukkan NIK Pasangan (16 angka)"
									defaultValue={dt.nik_pasangan}
									value={dt.nik_pasangan}
									onChange={e => changeInputText(e, "nik_pasangan")}
								/>
								<small id="emailHelp" className="form-text text-muted">
									Data NIK {formData.formPasangan === "none" ? "tidak" : ""}{" "}
									tersedia?{" "}
									<span
										style={{ cursor: "pointer", color: "#0000ff" }}
										onClick={() => {
											if (formData.formPasangan === "none") {
												if (props.getJenisInput) {
													props.getJenisInput("manual")
												}
											}
											else {
												if (props.getJenisInput) {
													props.getJenisInput("auto")
												}
											}
											dataPasangan()
										}}
									>
										Klik disini
									</span>
								</small>
							</Col>
						</FormGroup>
						<div
							style={{ display: formData.status.dataPenduduk2 }}
						>
							<Label
								className="col-sm-12 col-form-label font-weight-bold pl-0"
								htmlFor="inputEmail3"
							>
								Detail Data Pasangan
							</Label>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pasangan
								</Label>
								<Col sm="9">
									<input
										data-testid="nama_pasangan"
										name="nama_pasangan"
										className="form-control"
										id="nama_pasangan"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Contoh : Toni"
										defaultValue={dt.nama_pasangan}
										value={dt.nama_pasangan}
										onChange={e => changeInputText(e, "nama_pasangan")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir Pasangan
								</Label>
								<Col sm="9">
									<input
										data-testid="tempat_lahir_pasangan"
										name="tempat_lahir_pasangan"
										className="form-control"
										id="tempat_lahir_pasangan"
										type="text"
										required
										readOnly={formData.formPasangan === "" ? false : true}
										placeholder="Contoh : Jakarta"
										defaultValue={dt.tempat_lahir_pasangan}
										value={dt.tempat_lahir_pasangan}
										onChange={e =>
											changeInputText(e, "tempat_lahir_pasangan")
										}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir Pasangan
								</Label>
								<Col sm="9">
									{
										formData.formPasangan === ""
											?
											<Datetime
												inputProps={{ "data-testid": "tanggal_lahir_pasangan", placeholder: 'Klik disini untuk memilih tanggal', required: true }}
												// data-testid="tanggal_lahir_pasangan"
												inputId="tanggal_lahir_pasangan"
												name="tanggal_lahir_pasangan"
												locale="id-ID"
												input={true}
												timeFormat={false}
												closeOnTab={true}
												closeOnSelect={true}
												// dateFormat="yyyy-MM-DD"
												dateFormat="DD/MM/yyyy"
												initialValue={dt.tanggal_lahir_pasangan}
												value={dt.tanggal_lahir_pasangan}
												onChange={(e) => {
													gantiTgl(e, 'tanggal_lahir_pasangan');
												}}
											/>
											:
											<input
												className="form-control"
												id="tanggal_lahir_pasangan"
												type="text"
												readOnly
												placeholder="Tanggal Lahir"
												value={dt.tanggal_lahir_pasangan}
												defaultValue={dt.tanggal_lahir_pasangan}
												style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
												disabled={formData.formPasangan === "" ? false : true}
											/>
									}

								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Agama Pasangan
								</Label>
								<Col sm="9">
									{formData.formPasangan === 'none'
										?
										<input
											className="form-control"
											id="agama_pasangan"
											type="text"
											placeholder="Agama Pasangan"
											required
											style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
											value={dt.agama_pasangan ? dt.agama_pasangan.label : ''}
											readOnly
										/>
										:
										<Select
											// isDisabled={this.state.status.select}
											classNamePrefix="select"
											onChange={e => {
												changeSelectValue(e, "agama_pasangan");
											}}
											defaultValue={dt.agama_pasangan}
											value={dt.agama_pasangan}
											name="agama_pasangan"
											options={formData.frmAgm}
											placeholder="Pilih Agama Pasangan"
										// isClearable
										/>
									}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Pekerjaan Pasangan
								</Label>
								<Col sm="9">
									{formData.formPasangan === "" ? (
										<div data-testid="selectPekerjaan">
											<Select
												inputId="pekerjaan_pasangan"
												classNamePrefix="select"
												onChange={e => {
													changeSelectValue(e, "pekerjaan_pasangan");
												}}
												value={dt.pekerjaan_pasangan}
												name="pekerjaan_pasangan"
												options={formData.frmPkr}
												placeholder="Pilih Pekerjaan Pasangan"
											// isClearable
											/>
										</div>
									) : (
										<input
											id="pekerjaan_pasangan"
											type="text"
											className="form-control"
											readOnly
											value={dt.pekerjaan_pasangan ? dt.pekerjaan_pasangan.label : ''}
											style={{ backgroundColor: "#c9d1d8" }}
										/>
									)
									}
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Status Perkawinan Pasangan
								</Label>
								<Col sm="9">
									{formData.formPasangan === 'none'
										?
										<input
											className="form-control"
											id="status_perkawinan_pasangan"
											type="text"
											placeholder="Status Perkawinan Pasangan"
											required
											style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
											value={dt.status_perkawinan_pasangan ? dt.status_perkawinan_pasangan.label : ''}
											readOnly
										/>
										:
										<Select
											// isDisabled={this.state.status.select}
											classNamePrefix="select"
											onChange={e => {
												changeSelectValue(e, "status_perkawinan_pasangan");
											}}
											defaultValue={dt.status_perkawinan_pasangan}
											value={dt.status_perkawinan_pasangan}
											name="Status Perkawinan"
											options={formData.frmStatusPerkawinan}
											placeholder="Pilih Status Perkawinan Pasangan"
										// isClearable
										/>
									}
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat Pasangan
                                </Label>
                                <Col sm="9">
                                    <input
										data-testid="alamat_kk_pasangan"
										name="alamat_kk_pasangan"
										className="form-control"
										id="alamat_kk_pasangan"
										type="text"
										readOnly={formData.formPasangan === "" ? false : true}
										required
										placeholder="Contoh : Jalan Sudirman No. 2 Kec. Bandar Sari, Kab. Kampar, Riau"
										defaultValue={dt.alamat_kk_pasangan}
										value={dt.alamat_kk_pasangan}
										onChange={e => changeInputText(e, "alamat_kk_pasangan")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah Pasangan
                                </Label>
                                <Col sm="9">
                                    <input
										data-testid="alamat_pasangan"
										name="alamat_pasangan"
										className="form-control"
										id="alamat_pasangan"
										type="text"
										readOnly={formData.formPasangan === "" ? false : true}
										required
										placeholder="Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau"
										defaultValue={dt.alamat_pasangan}
										value={dt.alamat_pasangan}
										onChange={e => changeInputText(e, "alamat_pasangan")}

										style={formData.formPasangan === "" ? { backgroundColor: "" } : { backgroundColor: "#c9d1d8" }}
										disabled={formData.formPasangan === "" ? false : true}
									/>
                                    {
                                        formData.formPasangan === ""
                                        ?
                                            <small><font color="red">* Contoh : RT. 02/RW. 02, Dusun Bukit Durian, Desa Sungkur, Kec. Kampar Kiri Hilir, Kab. Kampar, Riau</font></small>
                                        :
                                            <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                    }
                                </Col>
                            </FormGroup>
						</div>
						<hr />

                        <div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
                            <b>Detail Data Pernikahan</b>
                        </div>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tanggal Menikah
							</Label>
							<Col sm="9">
								<Datetime
									inputProps={{ "data-testid": "tanggal_menikah", placeholder: 'Tanggal Menikah', required: true }}
									inputId="tanggal_menikah"
									name="tanggal_menikah"
									locale="id-ID"
									input={true}
									closeOnTab={true}
									closeOnSelect={true}
									timeFormat={false}
									dateFormat="DD/MM/yyyy"
									value={dt.tanggal_menikah}
									onChange={e => {
										gantiTgl(e, "tanggal_menikah");
									}}
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Tempat Menikah
							</Label>
							<Col sm="9">
								<input
									data-testid="tempat menikah"
									name="tempat_menikah"
									className="form-control"
									id="tempat_menikah"
									type="text"
									placeholder="Tempat Menikah"
									defaultValue={dt.tempat_menikah}
									value={dt.tempat_menikah}
									onChange={e => changeInputText(e, "tempat_menikah")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Petugas Nikah
							</Label>
							<Col sm="9">
								<input
									data-testid="petugas nikah"
									name="petugas_nikah"
									className="form-control"
									id="petugas_nikah"
									type="text"
									placeholder="Petugas Menikah"
									defaultValue={dt.petugas_nikah}
									value={dt.petugas_nikah}
									onChange={e => changeInputText(e, "petugas_nikah")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Wali Nikah
							</Label>
							<Col sm="9">
								<input
									data-testid="wali nikah"
									name="wali_nikah"
									className="form-control"
									id="wali_nikah"
									type="text"
									placeholder="Wali Menikah"
									defaultValue={dt.wali_nikah}
									value={dt.wali_nikah}
									onChange={e => changeInputText(e, "wali_nikah")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Mas Kawin
							</Label>
							<Col sm="9">
								<input
									data-testid="mas kawin"
									name="mas_kawin"
									className="form-control"
									id="mas_kawin"
									type="text"
									placeholder="Mas Kawin"
									defaultValue={dt.mas_kawin}
									value={dt.mas_kawin}
									onChange={e => changeInputText(e, "mas_kawin")}
									required
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="inputEmail3"
							>
								Saksi Nikah
							</Label>
							<Col sm="9">
								<input
									data-testid="saksi nikah"
									name="saksi_nikah"
									className="form-control"
									id="saksi_nikah"
									type="text"
									placeholder="Saksi Nikah"
									defaultValue={dt.saksi_nikah}
									value={dt.saksi_nikah}
									onChange={e => changeInputText(e, "saksi_nikah")}
									required
								/>
							</Col>
						</FormGroup>
						<hr />

						<FormGroup className="row">
							<Label
								className="col-sm-3 col-form-label"
								htmlFor="nik"
							>
								NIK Pelapor
							</Label>
							<Col sm="9">
								<div data-testid="selectNIK">
									<Select
										inputId="nik3"
										classNamePrefix="select"
										onChange={e => {
											getPenduduk(e, "nik3");
										}}
										defaultValue={formData.nik3Stat}
										value={formData.nik3Stat}
										name="penduduk"
										onInputChange={e => handleInputChangeNIK(e, "nik3")}
										options={formData.frmNik3}
										placeholder="Pilih NIK Pemohon"
										isClearable
									/>
								</div>
							</Col>
						</FormGroup>

						<div
							style={{ display: formData.status.dataPenduduk3 }}
						>
							<Label
								className="col-sm-12 col-form-label font-weight-bold pl-0"
								htmlFor="inputEmail3"
							>
								Detail Data Pelapor
							</Label>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Nama Pelapor
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="nama_pelapor"
										readOnly
										type="text"
										placeholder="nama_pelapor"
										value={dt.nama_pelapor}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tempat Lahir Pelapor
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										readOnly
										id="tempat_lahir_pelapor"
										type="text"
										placeholder="Tempat Lahir Pelapor"
										value={dt.tempat_lahir_pelapor}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
							<FormGroup className="row">
								<Label
									className="col-sm-3 col-form-label"
									htmlFor="inputEmail3"
								>
									Tanggal Lahir Pelapor
								</Label>
								<Col sm="9">
									<input
										className="form-control"
										id="tanggal_lahir_pelapor"
										readOnly
										type="text"
										placeholder="Tanggal Lahir Pelapor"
										value={dt.tanggal_lahir_pelapor}
										style={{ backgroundColor: "#c9d1d8" }}
										disabled
									/>
								</Col>
							</FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Alamat
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat_kk"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_kk_pelapor}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                    Wilayah
                                </Label>
                                <Col sm="9">
                                    <input
                                        className="form-control"
                                        id="alamat"
                                        type="text"
                                        // placeholder="Tempat Lahir"
                                        value={dt.alamat_pelapor}
                                        readOnly
                                        style={{ backgroundColor: "#c9d1d8" }}
                                        disabled
                                    />
                                    <small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
                                </Col>
                            </FormGroup>
						</div>

					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
						// disabled={formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalSuratPernahNikah;
